var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFlagMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,5.9l-0.6-3.1h-14v26.5h3.1V18.3h8.7l0.6,3.1h10.9V5.9H19z M24.6,18.3h-5.2l-0.6-3.1H7.4V5.9h8.3L16.4,9h8.2 V18.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagMenu);
export default __webpack_public_path__ + "static/media/icon_flag_menu.13abc75b3002cbaa35e0241b72ad5c43.svg";
export { ForwardRef as ReactComponent };